import DesignTokens from '@tableau/design-tokens';
import React from 'react';

import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';
import { cssClass } from '~src/style';
import { applyColor }from '~src/style/ColorService';

const PRIVATE_CONNECT_SETTINGS_PREFIX = 'privateconnect-settings';
const SETTINGS_CONTAINER_INDENT = '85px';

const prefix = 'grid-styles';
export const GridRowHeight = 44;

export const privateConnectSpaceContainer = cssClass(PRIVATE_CONNECT_SETTINGS_PREFIX, 'space', {
  display: 'block',
  paddingTop: CommonStyles.Sizes.XLargeSpace
});


export const privateConnectSettingsContainer = cssClass(PRIVATE_CONNECT_SETTINGS_PREFIX, 'container', {
  marginLeft: SETTINGS_CONTAINER_INDENT,
  paddingBottom: CommonStyles.Sizes.LargeSpace,
});


export const tableStyle: React.CSSProperties = {
    width: '100%',
    tableLayout: 'fixed',
    borderCollapse: 'collapse'
  };

  export const cellStyle: React.CSSProperties = {
    padding: '10px',
    paddingLeft: '0px',
    textAlign: 'left',
    borderBottom: '1px solid ' + applyColor(DesignTokens.color.elevation.border.default.subtle, '#ddd'),
  };


  export const headerStyle: React.CSSProperties = {
    fontWeight: 'bold',
    fontSize: '12px',
    borderBottom: '1px solid ' + applyColor(DesignTokens.color.elevation.border.default.subtle, '#ddd')
  };

  export const rowStyle: React.CSSProperties = {
    height: '44px'
  };


  export const tooltipCellStyle: React.CSSProperties = {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  };
